import { render, staticRenderFns } from "./RatesForApp.vue?vue&type=template&id=34424114&"
import script from "./RatesForApp.vue?vue&type=script&lang=js&"
export * from "./RatesForApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports